(function () {
  const reviewImages = document.querySelectorAll('.md-review__banner');

  reviewImages.forEach((image) => {
    const reviewModal = image.querySelector('.md-review__modal');
    document.body.append(reviewModal);

    image.addEventListener('click', () => {
      reviewModal.classList.add('active');
      document.body.classList.add('overflow-hidden-important');
    })

    reviewModal.addEventListener('click', (e) => {
      if (e.target == reviewModal && e.target.tagname != 'img')
        reviewModal.classList.remove('active');
      document.body.classList.remove('overflow-hidden-important');
    })
  });
})();
